import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";
import TrainingCompanySignup from "./layouts/pages/authentication/TrainingCompanySignup/TrainingCompanySignup";
import TrainingCompanySignin from "./pages/LandingPages/TrainingCompanySignIn/TrainingCompanySignIn";
import TrainerSignin from "./pages/LandingPages/TrainerSignIn/TrainerSignIn";
import TrainerSignup from "./layouts/pages/authentication/TrainerSignup/TrainerSignup";
import SignUp from "./layouts/pages/authentication/sign-up/sign-up";
import TrainerProfile from "./pages/LandingPages/TrainerProfile/TrainerProfile"
import TrainerProfileEdit from "./pages/LandingPages/TrainerProfileEdit/TrainerProfileEdit"
import TrainingCompanyProfile from "./pages/LandingPages/TrainingCompanyProfile/TrainingCompanyProfile"
import TrainingCompanyProfileEdit from "./pages/LandingPages/TrainingCompanyProfileEdit/TrainingCompanyProfileEdit"
import LogOut from "./pages/LandingPages/LogOut/LogOut";
import TrainerDashboard from "./pages/LandingPages/TrainerDashboard/TrainerDashboard";
import TrainerRecommendedTrainingSeeMore from "pages/LandingPages/TrainerRecommendedTrainingSeeMore/TrainerRecommendedTrainingSeeMore";
import TrainerRecruitSeeMore from "pages/LandingPages/TrainerRecruitSeeMore/TrainerRecruitSeeMore";
import TrainerAppliedTrainingSeeMore from "pages/LandingPages/TrainerAppliedTrainingSeeMore/TrainerAppliedTrainingSeeMore";
import TrainerAcceptedTrainingSeeMore from "pages/LandingPages/TrainerAcceptedTrainingSeeMore/TrainerAcceptedTrainingSeeMore";
import TrainerVanquishedTrainingSeeMore from "pages/LandingPages/TrainerVanquishedTrainingSeeMore/TrainerVanquishedTrainingSeeMore";
import TrainerCompletedTrainingSeeMore from "pages/LandingPages/TrainerCompletedTrainingSeeMore/TrainerCompletedTrainingSeeMore";
import TrainingCompanyDashboard from "./pages/LandingPages/TrainingCompanyDashboard/TrainingCompanyDashboard";
import ForgotPassword from "./pages/LandingPages/ForgotPassword/ForgotPassword";
import ForgotPasswordEmail from "./pages/LandingPages/ForgotPassword/ForgotPasswordEmail";
import TrainingPost from "./pages/LandingPages/TrainingPost/TrainingPost";
import TrainingListIndex from "./pages/LandingPages/TrainingList/TrainingListLanding";
import TrainingList from "./pages/LandingPages/TrainingList/TrainingAllList";
import TrainerListIndex from "./pages/LandingPages/TrainerList/TrainerListLanding";
import TrainerList from "./pages/LandingPages/TrainerList/TrainerAllListLanding";
import NavTrainerList from "./pages/LandingPages/NavTrainerList/NavTrainerList";
import NavTrainingList from "./pages/LandingPages/NavTrainingList/NavTrainingList";
import NavTrainingIndex from "./pages/LandingPages/NavTrainingList/NavTrainingIndex";
import NavTrainerIndex from "./pages/LandingPages/NavTrainerList/NavTrainerIndex";
import TrainerVerificationSuccess from "./pages/LandingPages/TrainerSignIn/VerificationSuccess";
import TrainingCompanyVerificationSuccess from "./pages/LandingPages/TrainingCompanySignIn/VerificationSuccess";
import TrainingCompanyNotification from "./pages/LandingPages/TrainingApply/TrainingCompanyNotification";
import TrainerTrainingNotification from "./pages/LandingPages/TrainingApply/TrainerTrainingNotification";
import TrainerDetailsToCompany from "./pages/LandingPages/TrainingApply/TrainerDetailsToCompany";
import TrainerCompanyNotification from "./pages/LandingPages/TrainerRecruit/TrainerCompanyNotification";
import CompanyTrainerNotification from "./pages/LandingPages/TrainerRecruit/CompanyTrainerNotification";
import CompanyDetailsToTrainer from "./pages/LandingPages/TrainerRecruit/CompanyDetailsToTrainer";
import TrainingDetails from "./pages/LandingPages/TrainingDetails/TrainingDetails";
import TrainerPendingAction from "./pages/LandingPages/TrainerPendingAction/TrainerPendingAction";
import EditTrainingPost from "./pages/LandingPages/EditTrainingPost/EditTrainingPost";
import TrainingCompanyPendingAction from "./pages/LandingPages/TrainingCompanyPendingAction/TrainingCompanyPendingAction";
import PostedTrainingSeeMore from "./pages/LandingPages/TrainingCompanyPostedTrainingSeeMore/PostedTrainingSeeMore";
import ActiveTrainingSeeMore from "./pages/LandingPages/TrainingCompanyActiveTrainingSeeMore/ActiveTrainingSeeMore";
import CompletedTrainingSeeMore from "./pages/LandingPages/TrainingCompanyCompletedTrainingSeeMore/CompletedTrainingSeeMore";
import CancelledTrainingSeeMore from "./pages/LandingPages/TrainingCompanyCancelledTrainingSeeMore/CancelledTrainingSeeMore";
import RecruitedTrainerSeeMore from "./pages/LandingPages/TrainingCompanyRecrutiedTrainerSeeMore/RecruitedTrainerSeeMore";
import RecommendedTrainerSeeMore from "./pages/LandingPages/RecommendedTrainerSeeMore/RecommendedTrainerSeeMore";
import AppliedTrainingMoreDetails from "./pages/LandingPages/AppliedTrainingMoreDetails/AppliedTrainingMoreDetails";
import RecruitedTrainingCompanyMoreDetails from "./pages/LandingPages/RecruitedTrainingCompanyMoreDetails/RecruitedTrainingCompanyMoreDetails";
import ActiveTrainingMoreDetails from "./pages/LandingPages/ActiveTrainingMoreDetails/ActiveTrainingMoreDetails";
import AppliedTrainerMoreDetails from "./pages/LandingPages/ActiveTrainingMoreDetails/AppliedTrainerMoreDetails";
import RecommendedTrainerMoreDetails from "./pages/LandingPages/RecommendedTrainerMoreDetails/RecommendedTrainerDetails";
import RecruitedTrainerMoreDetails from "./pages/LandingPages/RecruitedTrainerMoreDetails/RecruitedTrainerMoreDetails"
import TrainerMoreDetails from "./pages/LandingPages/TrainerMoreDetails/TrainerMoreDetails"
import Advertisement from "./pages/LandingPages/Advertisement/Advertisement";
import routes from "routes";
import jwtDecode from "jwt-decode";

export default function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  console.log(pathname);

  const getRoutes = (allRoutes) => {
    if (!Array.isArray(allRoutes)) {
      return null; // or handle differently based on your requirements
    }

    return allRoutes.map((route, index) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={index} />;
      }

      return null;
    });
  };

  const isAuthenticated = () => {
    if (localStorage.getItem('token')) {
      let token = localStorage.getItem('token')
      const { exp } = jwtDecode(token)
      const expirationTime = (exp * 1000) - 60000
      if (Date.now() >= expirationTime) {
        localStorage.clear();
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  console.log("Authenticated", isAuthenticated());
  console.log("localStorage.getItem", localStorage.getItem("group"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        {isAuthenticated() && (
          <>
            {localStorage.getItem("group") === "1" ? ( //Company
              <>
                <Route path="/app/logout" element={<LogOut />} />
                <Route path="/app/trainingcompanyprofile" element={<TrainingCompanyProfile />} />
                <Route path="/app/trainingcompanydashboard" element={<TrainingCompanyDashboard />} />
                <Route path="/app/trainingpost" element={<TrainingPost />} />
                <Route path="/app/trainerlistIndex" element={<TrainerListIndex />} />
                <Route path="/app/trainerlist" element={<TrainerList />} />
                <Route path="/app/navtrainerindex" element={<NavTrainerIndex />} />
                <Route path="/app/navtrainerlist" element={<NavTrainerList />} />
                <Route path="/app/activetrainingmoredetails/:trainingID" element={<ActiveTrainingMoreDetails />} />
                <Route path="/app/trainerMoreDetails/:trainerID" element={<TrainerMoreDetails />} />
                <Route path="/app/recruitedtrainermoredetails/:trainerID" element={<RecruitedTrainerMoreDetails />} />
                <Route path="/app/trainingcompanypendingaction" element={<TrainingCompanyPendingAction />} />
                <Route path="/app/postedtrainingseemore" element={<PostedTrainingSeeMore />} />
                <Route path="/app/activetrainingseemore" element={<ActiveTrainingSeeMore />} />
                <Route path="/app/completedtrainingseemore" element={<CompletedTrainingSeeMore />} />
                <Route path="/app/cancelledtrainingseemore" element={<CancelledTrainingSeeMore />} />
                <Route path="/app/recruitedtrainerseemore" element={<RecruitedTrainerSeeMore />} />
                <Route path="/app/recommendedtrainerseemore" element={<RecommendedTrainerSeeMore />} />
                <Route path="/app/edittrainingpost/:trainingID" element={<EditTrainingPost />} />
                <Route path="/app/trainingcompanyprofileedit/:trainingID" element={<TrainingCompanyProfileEdit />} />
                <Route path="/app/appliedtrainermoredetails/:trainingID" element={<AppliedTrainerMoreDetails />} />

              </>
            ) : (
              <>
                <Route path="/portal" element={<Presentation />} />
              </>
            )}
            {localStorage.getItem("group") === "2" ? (  //Trainer
              <>
                <Route path="/app/logout" element={<LogOut />} />
                <Route path="/app/trainerprofile" element={<TrainerProfile />} />
                <Route path="/app/trainerdashboard" element={<TrainerDashboard />} />
                <Route path="/app/traininglistindex" element={<TrainingListIndex />} />
                <Route path="/app/traininglist" element={<TrainingList />} />
                <Route path="/app/navtrainingindex" element={<NavTrainingIndex />} />
                <Route path="/app/navtraininglist" element={<NavTrainingList />} />
                <Route path="/app/trainingdetails/:trainingID" element={<TrainingDetails />} />
                <Route path="/app/recruitedtrainingcompanymoredetails/:trainingCompanyID" element={<RecruitedTrainingCompanyMoreDetails />} />
                <Route path="/app/trainerpendingaction" element={<TrainerPendingAction />} />
                <Route path="/app/trainerprofileedit/:trainingID" element={<TrainerProfileEdit />} />
                <Route path="/app/trainerrecommendedtrainingSeemore" element={<TrainerRecommendedTrainingSeeMore />} />
                <Route path="/app/trainerrecruitseemore" element={<TrainerRecruitSeeMore />} />
                <Route path="/app/trainerappliedtrainingseemore" element={<TrainerAppliedTrainingSeeMore />} />
                <Route path="/app/traineracceptedtrainingseemore" element={<TrainerAcceptedTrainingSeeMore />} />
                <Route path="/app/trainervanquishedtrainingseemore" element={<TrainerVanquishedTrainingSeeMore />} />
                <Route path="/app/trainercompletedtrainingseemore" element={<TrainerCompletedTrainingSeeMore />} />
                <Route path="/app/appliedtrainingmoredetails/:trainingID" element={<AppliedTrainingMoreDetails />} />
              </>
            ) : (
              <>
                <Route path="/portal" element={<Presentation />} />
              </>
            )}
            <Route path="/portal" element={<Presentation />} />
            <Route path="/app/trainingcompany" element={<TrainingCompanySignup />} />
            <Route path="/app/trainer" element={<TrainerSignup />} />
            <Route path="/app/signup" element={<SignUp />} />
            <Route path="/app/trainersignin" element={<TrainerSignin />} />
            <Route path="/app/trainingcompanysignin" element={<TrainingCompanySignin />} />
            <Route path="/app/forgotpassword/:uidb64/:token" element={<ForgotPassword />} />
            <Route path="/app/forgotpasswordemail" element={<ForgotPasswordEmail />} />
            <Route path="/app/trainerverificationsuccess" element={<TrainerVerificationSuccess />} />
            <Route path="/app/trainingcompanyverificationsuccess" element={<TrainingCompanyVerificationSuccess />} />
            <Route path="/app/recommendedtrainermoredetails/:trainerID" element={<RecommendedTrainerMoreDetails />} />
            <Route path="/app/trainingcompanynotification/:uidb64/:token/:appliedTrainerID/:trainingCompanyUserID/:selectedTrainingID/:selectedTrainingName" element={<TrainingCompanyNotification />} />
            <Route path="/app/trainingtrainernotification/:uidb64/:token/:appliedTrainerID/:trainingCompanyUserID/:selectedTrainingID/:selectedTrainingName" element={<TrainerTrainingNotification />} />
            <Route path="/app/trainerdetailstocompany/:uidb64/:token/:appliedTrainerID/:trainingCompanyUserID/:selectedTrainingID/:selectedTrainingName" element={<TrainerDetailsToCompany />} />
            <Route path="/app/trainercompanynotification/:uidb64/:token/:trainerID/:trainingCompanyID" element={<TrainerCompanyNotification />} />
            <Route path="/app/companytrainernotification/:uidb64/:token/:trainerID/:trainingCompanyID" element={<CompanyTrainerNotification />} />
            <Route path="/app/companydetailstotrainer/:uidb64/:token/:trainerID/:trainingCompanyID" element={<CompanyDetailsToTrainer />} />
            <Route path="/app/appliedtrainermoredetails/:trainingID" element={<AppliedTrainerMoreDetails />} />
            <Route path="/app/appliedtrainingmoredetails/:trainingID" element={<AppliedTrainingMoreDetails />} />
            <Route path="/app/advertisement" element={<Advertisement />} />
            <Route path="*" element={<Navigate to="/portal" />} />
            <Route path="/" element={<Navigate to="/portal" />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/portal" />} />
        <Route path="/" element={<Navigate to="/portal" />} />
        <Route path="/portal" element={<Presentation />} />
        <Route path="/app/signup" element={<SignUp />} />
        <Route path="/app/trainersignin" element={<TrainerSignin />} />
        <Route path="/app/trainingcompanysignin" element={<TrainingCompanySignin />} />
        <Route path="/app/forgotpassword/:uidb64/:token" element={<ForgotPassword />} />
        <Route path="/app/forgotpasswordemail" element={<ForgotPasswordEmail />} />
        <Route path="/app/logout" element={<LogOut />} />
        <Route path="/app/advertisement" element={<Advertisement />} />
        <Route path="/app/traininglistindex" element={<TrainingListIndex />} />
        <Route path="/app/traininglist" element={<TrainingList />} />
        <Route path="/app/trainerlistIndex" element={<TrainerListIndex />} />
        <Route path="/app/trainerlist" element={<TrainerList />} />
        <Route path="/app/trainingcompany" element={<TrainingCompanySignup />} />
        <Route path="/app/trainer" element={<TrainerSignup />} />
        <Route path="/app/trainerverificationsuccess" element={<TrainerVerificationSuccess />} />
        <Route path="/app/trainingcompanyverificationsuccess" element={<TrainingCompanyVerificationSuccess />} />
        <Route path="/app/navtrainerindex" element={<NavTrainerIndex />} />
        <Route path="/app/navtrainerlist" element={<NavTrainerList />} />
        <Route path="/app/navtrainingindex" element={<NavTrainingIndex />} />
        <Route path="/app/navtraininglist" element={<NavTrainingList />} />
        <Route path="/app/trainingcompanynotification/:uidb64/:token/:appliedTrainerID/:trainingCompanyUserID/:selectedTrainingID/:selectedTrainingName" element={<TrainingCompanyNotification />} />
        <Route path="/app/trainingtrainernotification/:uidb64/:token/:appliedTrainerID/:trainingCompanyUserID/:selectedTrainingID/:selectedTrainingName" element={<TrainerTrainingNotification />} />
        <Route path="/app/trainerdetailstocompany/:uidb64/:token/:appliedTrainerID/:trainingCompanyUserID/:selectedTrainingID/:selectedTrainingName" element={<TrainerDetailsToCompany />} />
        <Route path="/app/trainercompanynotification/:uidb64/:token/:trainerID/:trainingCompanyID" element={<TrainerCompanyNotification />} />
        <Route path="/app/companytrainernotification/:uidb64/:token/:trainerID/:trainingCompanyID" element={<CompanyTrainerNotification />} />
        <Route path="/app/companydetailstotrainer/:uidb64/:token/:trainerID/:trainingCompanyID" element={<CompanyDetailsToTrainer />} />
      </Routes>
    </ThemeProvider>
  );
}
